import React from "react";

const NotFound = () => {
  return (
    <section class="prt-row error-404">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-lg-12 col-md-12">
            <div class="page-content-main text-center">
              <div class="page-content">
                <h2><i class="fa fa-thumbs-o-down"></i></h2>
                <h3>Error 404</h3>
                <p>La página no se ha encontrado.</p>
              </div>
              <div class="">
                <a class="prt-btn prt-btn-size-md prt-btn-shape-square prt-btn-style-fill prt-btn-color-skin" href="/">Volver al inicio</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
